/**
 * User CBLC Definition Type.
 */
export enum CblcType {
    /**
     * The user is owner of the CBLC account.
     */
    Owner = 0,

    /**
     * The user is representative for the company owner of CBLC account.
     */
    Representative = 1,

    /**
     * The user is emitter for the company owner of CBLC account.
     */
    Emitter = 2,

    /**
     * The user is attorney for the company owner of CBLC account.
     */
    Attorney = 3
}